import React, { useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { add, update } from "../../service/equipmentTypesService";
import { Grid } from "@mui/material";
import IntervalDropdown from "../../components/IntervalDropdown";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dropdown } from "primereact/dropdown";
import { FREQUENCIES } from "../forms-allocation/constants";
import DropdownApi from "../../components/DropdownApi";
import { Input, MultiSelect, Select } from "../../components/Shared/Forms";
import useApiService from "../../hooks/useApiService";
export default function EquipmentAdd(modalProps: any) {
  const details = modalProps?.details;

  const [name, setName] = useState(details?.name || "");
  const [nameError, setNameError] = useState(false);
  const [maintenanceValue, setMaintenanceValue] = useState(details?.maintenance_value || 0);
  const [maintenanceInterval, setMaintenanceInterval] = useState(
    details?.maintenance_interval || ""
  );
  const [expectedLifeValue, setExpectedLifeValue] = useState(details?.expected_life_value || 0);
  const [expectedLifeInterval, setExpectedLifeInterval] = useState(
    details?.expected_life_interval || ""
  );
  const [hazard, setHazard] = useState(details?.hazard || "");

  const [appointment, setAppointment] = useState(details?.appointment || "");

  const [safeEquipmentChecklist, setSafeEquipmentChecklist] = useState(
    details?.equipment_safe_checklist || [""]
  );

  const [riskEquipmentChecklist, setRiskEquipmentChecklist] = useState(
    details?.equipment_risk_checklist || [""]
  );

  const [frequency, setFrequency] = useState(details?.frequency || 1);

  const [safeWorkMethod, setSafeWorkMethod] = useState(details?.safe_work_method || "");

  const [relevantAppointment, setRelevantAppointment] = useState(details?.relevant_appointment || "");

  const { loading: loadingRiskHazards, data: riskHazardData } = useApiService<any[]>({
    url: "risk-hazard",
    method: "GET",
    apiName: "core",
  });

  const { loading: safeWorkMethodLoading, data: safeWorkMethodData } = useApiService<any[]>({
    url: "safe-work-method",
    method: "GET",
    apiName: "core",
  });

  const { loading: appointmentsLoading, data: appointmentsData } = useApiService<any[]>({
    url: "appointments",
    method: "GET",
    apiName: "core",
  });

  async function addIndustry() {
    setNameError(!name || name === "");
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter all required fields",
        life: 3000,
      });
      return;
    }
    const updateDetails = {
      name,
      maintenance_interval: maintenanceInterval,
      maintenance_value: maintenanceValue,
      expected_life_value: expectedLifeValue,
      expected_life_interval: expectedLifeInterval,
      hazard,
      equipment_safe_checklist: safeEquipmentChecklist,
      equipment_risk_checklist: riskEquipmentChecklist,
      appointment: appointment,
      frequency: frequency,
      safe_work_method: safeWorkMethod,
      relevant_appointment: relevantAppointment,
    };
    if (modalProps.id) {
      update(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Equipment Type Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      add(updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Equipment Type Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <div style={{ position: "relative" }}>
      <TabView>
        <TabPanel header="Details">
          <div>
            <div>
              <Input
                value={name}
                onChange={(e: any) => setName(e.target.value)}
                placeholder={"Equipment Type"}
                label={"Equipment Type"}
                required={true}
              />
            </div>
            <div className={"flex gap-4"}>
              <div>
                <IntervalDropdown
                  label="Maintenance"
                  selectedInterval={maintenanceInterval}
                  setSelectedInterval={setMaintenanceInterval}
                  selectedValue={maintenanceValue}
                  setSelectedValue={setMaintenanceValue}
                />
              </div>
              <div>
                <IntervalDropdown
                  label="Expected Life"
                  selectedInterval={expectedLifeInterval}
                  setSelectedInterval={setExpectedLifeInterval}
                  selectedValue={expectedLifeValue}
                  setSelectedValue={setExpectedLifeValue}
                />
              </div>
            </div>

            <div className={"mt-4"}>
              <MultiSelect
                options={
                  riskHazardData?.map(item => ({
                    value: item.id,
                    label: item.name,
                  })) ?? []
                }
                label={"Hazard"}
                value={hazard}
                onChange={e => setHazard(e.value)}
                onSelectAll={e => {
                  setHazard(e);
                }}
                loading={loadingRiskHazards}
              />
            </div>
            <div>
              <Select
                options={
                  safeWorkMethodData?.map(item => ({
                    value: item.id,
                    label: item.name,
                  })) ?? []
                }
                filter={true}
                label={"Safe Work Method"}
                value={safeWorkMethod}
                onChange={e => setSafeWorkMethod(e.value)}
                loading={safeWorkMethodLoading}
              />
            </div>

            <div>
              <Input
                value={frequency}
                onChange={(e: any) => setFrequency(e.target.value)}
                type={"number"}
                label={"Checklist Frequency (in days)"}
              />
            </div>
            <div>
              <Select
                options={
                  appointmentsData?.map(item => ({
                    value: item.id,
                    label: item.name,
                  })) ?? []
                }
                filter={true}
                label={"Checklist Appointment"}
                value={appointment}
                onChange={e => setAppointment(e.value)}
                showClear={true}
                loading={appointmentsLoading}
              />
            </div>
            <div>
              <MultiDropdownApi
                apiPath="appointments"
                optionLabel="name"
                optionValue="id"
                label="Relevant Appointments"
                selectedData={relevantAppointment}
                setSelectedData={setRelevantAppointment}
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Checklist">
          <TabView>
            <TabPanel header="Safe">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                    <FormLabel>Questions</FormLabel>
                  </FormControl>
                </Grid>
                {safeEquipmentChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...safeEquipmentChecklist];
                            updatedChecklist.splice(index, 1);
                            setSafeEquipmentChecklist(updatedChecklist);
                          }}
                        />

                        <InputText
                          value={checklist}
                          onChange={e => {
                            const updatedChecklist = [...safeEquipmentChecklist];
                            updatedChecklist[index] = e.target.value;
                            setSafeEquipmentChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    marginTop: "1rem",
                  }}
                >
                  <Button
                    type="button"
                    icon="pi pi-plus"
                    label="Add"
                    className="p-button-outlined"
                    size="small"
                    onClick={() => {
                      const updatedChecklist = [...safeEquipmentChecklist];
                      updatedChecklist.push("");
                      setSafeEquipmentChecklist(updatedChecklist);
                    }}
                  />
                </div>
              </Grid>
            </TabPanel>
            <TabPanel header="At Risk">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                    <FormLabel>Questions</FormLabel>
                  </FormControl>
                </Grid>
                {riskEquipmentChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...riskEquipmentChecklist];
                            updatedChecklist.splice(index, 1);
                            setRiskEquipmentChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={e => {
                            const updatedChecklist = [...riskEquipmentChecklist];
                            updatedChecklist[index] = e.target.value;
                            setRiskEquipmentChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "1rem",
                    width: "100%",
                  }}
                >
                  <Button
                    type="button"
                    icon="pi pi-plus"
                    label="Add"
                    className="p-button-outlined"
                    size="small"
                    onClick={() => {
                      const updatedChecklist = [...riskEquipmentChecklist];
                      updatedChecklist.push("");
                      setRiskEquipmentChecklist(updatedChecklist);
                    }}
                  />
                </div>
              </Grid>
            </TabPanel>
          </TabView>
        </TabPanel>
      </TabView>
      <br />
      <br />

      <CardOverflow
        style={{ width: "100%", position: "sticky", bottom: 0, right: 0, zIndex: 99999 }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              color: "#2dd36f",
            }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </div>
  );
}
